export class HdsdFile {
    Id:number=0;
    Ten:string="";
    FileUpload:string="";
    TenFileLuu:string="";
    Loai:number=0;
    TenLoai:string="";
    TrangThai:boolean=true;
    Ids: string = "";
    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}
    export class CheckRole {
        Check:number=0;
        constructor(values: Object = {}) {
            Object.assign(this, values);
        }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/sys-hdsd/sys-hdsd.ts